import { render } from "./AuthHero.vue?vue&type=template&id=1ba757a0"
import script from "./AuthHero.vue?vue&type=script&lang=js"
export * from "./AuthHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__